import React from "react";
import {Col, Row} from "antd";
import {MainPage, MenuItem} from "./index.styles";
import {MyImage, MyText} from "../../components";
import {useAuth} from "../../hooks";
import MainImage from '../../assets/images/main-image.png'
import {Footer} from "../../layout";

export const Main = () => {
  const {menu} = useAuth()


  return (
    <>
      <MainPage justify='center'>
        <Col span={20}>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              {/*<MyText size={24} weight={500} align='center' style={{width: '100%', display: "block"}}>*/}
              {/*  КГКП «Саранский высший гуманитарно-технический колледж им. Абая Кунанбаева»*/}
              {/*</MyText>*/}
            </Col>

            {/*<Col span={24}>*/}
            {/*  <MyImage src={Banner}/>*/}
            {/*</Col>*/}


            <Col span={24}>
              <Row gutter={20} align='middle'>

              </Row>
            </Col>
          </Row>
        </Col>
      </MainPage>

      <Footer/>
    </>

  )
}